import { useState } from "react";
import SaveStatusIndicator from "./SaveStatusIndicator";
import { SaveStatus } from "common/utils/types";
import Button from "ui/buttons/Button";

## All States

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <span style={{ width: "80px", fontSize: "0.75rem", color: "#64748b" }}>Saved:</span>
    <SaveStatusIndicator status={SaveStatus.SAVED} savedAt={new Date()} />
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <span style={{ width: "80px", fontSize: "0.75rem", color: "#64748b" }}>Saving:</span>
    <SaveStatusIndicator status={SaveStatus.SAVING} savedAt={new Date()} />
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <span style={{ width: "80px", fontSize: "0.75rem", color: "#64748b" }}>Pre-save:</span>
    <SaveStatusIndicator status={SaveStatus.PRE_SAVE} savedAt={new Date()} />
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <span style={{ width: "80px", fontSize: "0.75rem", color: "#64748b" }}>Error:</span>
    <SaveStatusIndicator status={SaveStatus.ERROR} savedAt={new Date()} />
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <span style={{ width: "80px", fontSize: "0.75rem", color: "#64748b" }}>Offline:</span>
    <SaveStatusIndicator status={SaveStatus.OFFLINE} savedAt={new Date()} />
  </div>
</div>

Hover over each indicator to see the tooltip.

---

## Interactive Demo

export function SaveStatusDemo() {
  const [status, setStatus] = useState(SaveStatus.SAVED);
  const [savedAt, setSavedAt] = useState(new Date());
  const simulateSave = () => {
    setStatus(SaveStatus.SAVING);
    setTimeout(() => {
      setStatus(SaveStatus.SAVED);
      setSavedAt(new Date());
    }, 2000);
  };
  const simulateError = () => {
    setStatus(SaveStatus.SAVING);
    setTimeout(() => {
      setStatus(SaveStatus.ERROR);
    }, 1000);
  };
  return (
    <div>
      <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
        <Button btnStyle="tertiary" btnSize="small" onClick={simulateSave}>Simulate Save</Button>
        <Button btnStyle="tertiary" btnSize="small" onClick={simulateError}>Simulate Error</Button>
        <Button btnStyle="tertiary" btnSize="small" onClick={() => setStatus(SaveStatus.OFFLINE)}>Go Offline</Button>
      </div>
      <SaveStatusIndicator status={status} savedAt={savedAt} />
    </div>
  );
}

<SaveStatusDemo />

---

## In a Header

<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1rem", borderBottom: "1px solid #e5e5e5" }}>
  <h3 style={{ margin: 0 }}>Project Settings</h3>
  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <SaveStatusIndicator status={SaveStatus.SAVED} savedAt={new Date(Date.now() - 60000)} />
    <Button btnStyle="primary" btnSize="small">Save</Button>
  </div>
</div>

